import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { API_URL } from "../apiConfig";

function PartnerCardPreview({ item }) {
  if (!item) return null;

  const apiBase = useMemo(() => API_URL.replace(/\/api\/?$/, ""), []);
  const photoSrc = useMemo(() => {
    if (!item?.photoUrl) return "";
    return /^https?:\/\//i.test(item.photoUrl) ? item.photoUrl : `${apiBase}${item.photoUrl}`;
  }, [item?.photoUrl, apiBase]);

  const whatsappLink = useMemo(() => {
    if (!item) return "";
    const digits = String(item.whatsappPhone || item.phone || "").replace(/\D/g, "");
    if (!digits) return "";
    const phoneParam = digits.length <= 11 && !digits.startsWith("55") ? `55${digits}` : digits;
    const message = item.whatsappMessage || `Gostaria de saber mais sobre esse benefício da ${item.company || "Euro Privilege"}`;
    return `https://api.whatsapp.com/send/?phone=${phoneParam}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;
  }, [item]);

  return (
    <div className="privilege-benefits-card" style={{
      borderRadius: '24px',
      background: '#fff',
      boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxWidth: '280px',
      margin: '0 auto'
    }}>
      {photoSrc && (
        <div className="privilege-benefits-card__media" style={{ position: 'relative', overflow: 'hidden' }}>
          <img
            src={photoSrc}
            alt={item.company || item.benefit || ""}
            style={{
              width: '100%',
              height: '320px',
              objectFit: 'cover',
              objectPosition: 'center center',
              display: 'block',
              borderTopLeftRadius: '24px',
              borderTopRightRadius: '24px'
            }}
          />
        </div>
      )}

      <div className="privilege-benefits-card__body" style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', flex: 1 }}>
        {item.category && (
          <span style={{ background: '#eef2ff', color: '#4338ca', fontWeight: '600', fontSize: '0.75rem', padding: '0.15rem 0.75rem', borderRadius: '999px', alignSelf: 'flex-start', marginBottom: '0.5rem' }}>{item.category}</span>
        )}

        <h4 style={{ margin: 0 }}>{item.company || "Parceiro"}</h4>

        <p style={{ margin: '0 0 0.5rem 0', color: '#475467', fontWeight: '600' }}>{item.benefit || ""}</p>

        {item.benefitDescription && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem', flex: 1 }}>{item.benefitDescription}</p>
        )}

        <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginBottom: '0.75rem', display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
          {(item.cities || []).map((cityData, idx) => {
            const cityState = [cityData.city, cityData.state].filter(Boolean).join("-");
            return cityState ? (
              <span key={idx} style={{ background: '#f1f5f9', color: '#475569', padding: '0.15rem 0.5rem', borderRadius: '999px', fontSize: '0.75rem', fontWeight: '500' }}>{cityState}</span>
            ) : null;
          })}
        </div>

        { (whatsappLink && false) ? null : (
          <a style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', borderRadius: '999px', padding: '0.5rem 1rem', background: '#25d366', color: '#fff', textDecoration: 'none', fontWeight: '600' }}>
            Quero esse benefício
          </a>
        )}
      </div>
    </div>
  );
}

PartnerCardPreview.propTypes = {
  item: PropTypes.object,
};

export default PartnerCardPreview;
